import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Parents
const ParentsListPage = lazy(
  () => import("@/features/admin-view/parents/pages/parents-list")
);
const ParentsDetailsPage = lazy(
  () => import("@/features/admin-view/parents/pages/parents-details")
);
const CreateMemberPage = lazy(
  () => import("@/features/admin-view/members/pages/create-member")
);
const ImportParentsPage = lazy(
  () => import("@/features/admin-view/parents/pages/import-parents")
);
const ImportParentsFilesListPage = lazy(
  () => import("@/features/admin-view/parents/pages/import-parents-files-list")
);
const ImportParentsErrorDetailsPage = lazy(
  () =>
    import("@/features/admin-view/parents/pages/import-parents-error-details")
);

export const parentsAdminRoutes: RouteObject[] = [
  {
    path: "/admin/parents/:slug",
    element: (
      <RequirePermission resource="users">
        <ParentsListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/parents/add",
    element: (
      <RequirePermission resource="users">
        <CreateMemberPage isParent={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/parents/:idpId/view/:slug",
    element: (
      <RequirePermission resource="users">
        <ParentsDetailsPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/parents/import/:slug",
    element: (
      <RequirePermission resource="users">
        <ImportParentsPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/parents/import-parents-files-list/:slug",
    element: (
      <RequirePermission resource="users">
        <ImportParentsFilesListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/parents/import-parents-error-details/:slug/:importId",
    element: (
      <RequirePermission resource="users">
        <ImportParentsErrorDetailsPage />
      </RequirePermission>
    ),
  },
];
